export * from './rtc'
export * from './typings'
export * from './live/createLive'
export * from './live/createLiveReact'
export * from './live/live'
export * from './utils/subscribe'

/** 在控制台输出 __REALSEE_LIVE_PACKAGE_NAME__@__REALSEE_LIVE_PACKAGE_VERSION__ 的徽章（可控开关） */
declare const __REALSEE_LIVE_PACKAGE_NAME__: string
declare const __REALSEE_LIVE_PACKAGE_VERSION__: string
declare const __REALSEE_LIVE_BUILD_TIME__: string

// 通过全局开关控制是否打印徽章
// @ts-ignore
const __REALSEE_LIVE_BADGE_LOG__ = (globalThis as any).__REALSEE_LIVE_BADGE_LOG__
if (__REALSEE_LIVE_BADGE_LOG__ ?? true) {
  // eslint-disable-next-line no-console
  console.log(
    `%c${__REALSEE_LIVE_PACKAGE_NAME__}@${__REALSEE_LIVE_PACKAGE_VERSION__}${
      __REALSEE_LIVE_BUILD_TIME__ ? ` (${__REALSEE_LIVE_BUILD_TIME__})` : ''
    }`,
    'background: linear-gradient(to right, #1890ff, #52c41a); color: white; padding: 3px 6px; border-radius: 4px; font-weight: bold; text-shadow: 0 1px 0 rgba(0,0,0,0.2);',
  )
}
